import api from "..";
import { playListPassword, playListUrl, playListUsername } from "../../../state";
import { chunkArrayChannel, convertItemsToTilesChannel } from "../formatters/ItemFormatter";

const cache = new Map<string, Promise<any>>();
const leftoverTiles = new Map<string, any[]>();

export default function (filter: string, category_id: string) {
  return (pageIndex: number): Promise<any> => {
    const username = playListUsername();
    const password = playListPassword();
    const currentPlaylistUrl = playListUrl();
    const cacheKey = `${username}_${category_id}`;

    const url = `/player_api.php?username=${username}&password=${password}&action=get_live_streams&category_id=${category_id}`;
    const favoriteChannels = localStorage.getItem("@favoriteChannels");

    let favoriteChannelsArray: any = favoriteChannels ? JSON.parse(favoriteChannels) : [];

    if (category_id === "99999") {
      const currentPlaylistFavorites = favoriteChannelsArray.filter(
        (favChannel: any) => favChannel.playlistUrl === currentPlaylistUrl,
      );
      const chunks = chunkArrayChannel(currentPlaylistFavorites);
      console.log("hyri te 999", chunks);
      console.log("filtered favorites for current playlist:", currentPlaylistFavorites);
      return Promise.resolve(currentPlaylistFavorites);
    }

    if (cache.has(cacheKey)) {
      return cache.get(cacheKey);
    }

    const result = api._get(url).then(channels => {
      if (!channels) {
        // Fetch returned null due to network error — don't cache, allow retry
        cache.delete(cacheKey);
        return [];
      }

      const tileKey = `${filter}_${category_id}`;
      const existingTiles = leftoverTiles.get(tileKey) || [];
      const tiles = existingTiles.concat(convertItemsToTilesChannel(channels));
      const chunks = chunkArrayChannel(tiles);

      return channels;
    }).catch((err) => {
      console.error("[channels] failed to load channels:", err);
      cache.delete(cacheKey);
      return [];
    });

    cache.set(cacheKey, result);
    return result;
  };
}